module.exports = __webpack_public_path__ + "img/flandre scarlet_sc2.29ec7ce8.png";